import { render } from "./PVFarmView.vue?vue&type=template&id=1623a101&scoped=true&ts=true"
import script from "./PVFarmView.vue?vue&type=script&lang=ts"
export * from "./PVFarmView.vue?vue&type=script&lang=ts"

import "./PVFarmView.vue?vue&type=style&index=0&id=1623a101&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1623a101"]])

export default __exports__